/** Misma escala que comités en la web (rejilla 12 columnas). */
export const CONGRESO_ANCHO_GRILLA_VALIDOS = [33, 50, 66, 100];

/**
 * @param {*} v
 * @param {number} [fallback=100] — p. ej. comités usan 50 por defecto en su normalizador.
 */
export function normalizeCongresoAnchoGrilla(v, fallback = 100) {
  const n = Number(v);
  return CONGRESO_ANCHO_GRILLA_VALIDOS.includes(n) ? n : fallback;
}

export function anchoGrillaToSpan12(ancho) {
  const n = Number(ancho);
  if (n === 33) return 4;
  if (n === 66) return 8;
  if (n === 100) return 12;
  return 6;
}
